module.exports = __webpack_public_path__ + "static/media/textile_factory.3bb87d97.png";